var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1765_12637",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0027 -0.00390625H2.99686C1.33931 -0.00390625 -0.00439453 1.3398 -0.00439453 2.99734V13.0015C-0.00439453 14.6591 1.33931 16.0028 2.99686 16.0028H5.63796L5.05771 17.0032C4.7003 17.6222 4.7003 18.385 5.05771 19.004C5.41832 19.6287 6.08721 20.0109 6.80844 20.0044H13.2711C13.9852 20.0037 14.6448 19.6224 15.0019 19.004C15.3593 18.385 15.3593 17.6222 15.0019 17.0032L14.4116 16.0028H17.0027C18.6602 16.0028 20.0039 14.6591 20.0039 13.0015V2.99734C20.0039 1.3398 18.6602 -0.00390625 17.0027 -0.00390625ZM6.76843 18.0036L7.99894 16.0028H12.0006L13.2011 18.0036H6.76843ZM18.0031 13.0015C18.0031 13.554 17.5552 14.0019 17.0027 14.0019H2.99686C2.44434 14.0019 1.99644 13.554 1.99644 13.0015V12.0011H18.0031V13.0015ZM18.0031 10.0003H1.99644V2.99736C1.99644 2.44485 2.44434 1.99695 2.99686 1.99695H17.0027C17.5552 1.99695 18.0031 2.44485 18.0031 2.99736V10.0003Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1765_12637)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#828282"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.15670125e6f931057aa1953514bc925b.svg";
export { ForwardRef as ReactComponent };